import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import SelectAll from "./SelectAll";
import SelectedCount from "./SelectedCount";

const Selects = withLiteObserverAndTheme(() => {
  return (
    <ET3Div
      width={1510}
      height={100}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <Et3Margin top={0} bottom={0} left={10} right={0} />
      <SelectAll />
      <Et3Margin top={0} bottom={0} left={480} right={480} />
      <SelectedCount />
    </ET3Div>
  );
});

export default Selects;
